export enum SiteRFPMilestoneTypeAPIResponse {
  RFPRelease = 'rfpRelease',
  RFPAward = 'rfpAward',
  ContractEffectiveDate = 'contractEffectiveDate',
  Interconnection = 'interconnection',
  ProgramAward = 'programAward',
  Permits = 'permits',
  NTP = 'ntp',
  Construction = 'construction',
  MechanicalCompletion = 'mechanicalCompletion',
  PTO = 'pto',
  COD = 'cod',
}
